<template lang="pug">
	.liveticker-title
		h1.title Liveticker
		transition
			sponsored-by(
				v-if="sponsor"
				:sponsor="sponsor"
				:sponsor-link="sponsorLink"
			)
</template>


<script>
import SponsoredBy from '../components/SponsoredBy'
export default {
	components: {
		SponsoredBy
	},
	props: {
		sponsor: Object,
		sponsorLink: String
	}

}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/bulma-variables.scss';
.liveticker-title {
	display: flex;
	justify-content: flex-start;
	align-items: flex-end;
	flex-wrap: wrap;
	font-family: 'Bunday Sans', sans-serif;

	.title {
		margin-right: 10px;
		margin-bottom: 0;
		display: inline-block;
    padding: 0.4em 0.7em;
    background: #102E61;
    color: white;
		text-transform: uppercase;
		

		@media screen and (max-width: 768px) {
			font-size: 1.6em;
		}
	}

}


</style>
